// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"3b6e0d78","126":"24e67e32","171":"ef0a7e3b","220":"985957f1","453":"59bbecaa","842":"ac37956b","998":"891844ea"}[chunkId] + ".chunk.js";
};